import { render, staticRenderFns } from "./IconBolt.vue?vue&type=template&id=b87e95d0&"
import script from "./IconBolt.vue?vue&type=script&lang=js&"
export * from "./IconBolt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports